// extracted by mini-css-extract-plugin
export var form = "change-password-module--form--5a892";
export var input = "change-password-module--input--357da";
export var loginButton = "change-password-module--loginButton--3ed54";